import * as c from '../../constants.js';

export const globalDomainUri = c.globalDomainUri;

export const failure = c.failure;

export const globalUnhandledMessage = `${globalDomainUri}.errors.unhandled_message`;
export const globalAlreadySeen = `${globalDomainUri}.errors.already_seen`;
export const globalInvalidDomain = `${globalDomainUri}.errors.invalid_domain`;
export const globalInvalidContext = `${globalDomainUri}.errors.invalid_context`;
export const globalAuthenticationFailure = `${globalDomainUri}.errors.authentication.failure`;
export const globalInvalidPeer = `${globalDomainUri}.errors.invalid_peer`;
